import { Flex } from 'components/layout';
import { Typography } from 'components/typography';

import banner from '../../assets/banner.png';

export default function DrumkitIntro(): React.JSX.Element {
  return (
    <Flex direction='col' gap='2xl' className='h-full'>
      <img src={banner} alt='Drumkit banner' title='Drumkit banner' />
      <Flex direction='col' gap='md' className='px-4'>
        <Typography>
          Drumkit is an Outlook add-on for logistics operations teams that helps
          automate fundamental workflows like:
        </Typography>
        <ul className='list-disc ml-4 text-neutral-900'>
          <li>Quoting</li>
          <li>Building loads</li>
          <li>Finding carriers</li>
          <li>Scheduling appointments</li>
          <li>Tracking shipments</li>
        </ul>
        <Typography>
          You can do 90% of your job without ever leaving your inbox!
        </Typography>
        <Typography>Get started by signing in.</Typography>
      </Flex>
    </Flex>
  );
}
